export default __webpack_public_path__ + "static/media/icon_15.a9cfdb81.png";